import React, { useEffect, useMemo, useState } from 'react';
import { FiArrowLeft, FiPrinter } from 'react-icons/fi';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getBatchQrCodes } from '../services/api';

const publicLandingUrl =
  process.env.REACT_APP_PUBLIC_LANDING_URL || 'https://loyalty.sailabrasive.com/';

const buildQrDestination = (value: string) => `${publicLandingUrl}?qr=${encodeURIComponent(value)}`;

const buildQrImageUrl = (value: string, size = 260) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=10&data=${encodeURIComponent(buildQrDestination(value))}`;

const QrLabelPrintPage: React.FC = () => {
  const { batchNumber = '' } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [codes, setCodes] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const batch = (location.state as any)?.batch;

  useEffect(() => {
    const loadCodes = async () => {
      try {
        const res = await getBatchQrCodes(batchNumber);
        setCodes(res.data.data || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    loadCodes();
  }, [batchNumber]);

  const printableCodes = useMemo(
    () => codes.filter((code) => code.qrUuid),
    [codes]
  );

  return (
    <div className="page-container">
      <div className="qr-label-page-header no-print">
        <div>
          <h1>QR Label Print</h1>
          <p>
            Batch <strong>{batchNumber}</strong>
            {batch?.productName ? ` • ${batch.productName}` : ''}
            {typeof batch?.quantity === 'number' ? ` • ${batch.quantity} labels` : ''}
          </p>
        </div>
        <div className="qr-label-page-actions">
          <button className="btn btn-outline" onClick={() => navigate(-1)}>
            <FiArrowLeft /> Back
          </button>
          <button className="btn btn-primary" onClick={() => window.print()}>
            <FiPrinter /> Print Labels
          </button>
        </div>
      </div>

      {loading ? (
        <div className="card">
          <div className="loading">Loading labels...</div>
        </div>
      ) : (
        <div className="qr-label-sheet">
          {printableCodes.map((code: any, index: number) => (
            <div className="qr-label-card" key={code.qrId || code.qrUuid}>
              <div className="qr-label-card-top">
                <span className="badge badge-info">Label {index + 1}</span>
                <span className={`badge ${code.status === 'active' ? 'badge-success' : 'badge-warning'}`}>
                  {code.status}
                </span>
              </div>
              <div className="qr-label-brand">LANCER Loyalty</div>
              <img
                className="qr-label-image"
                src={buildQrImageUrl(code.qrUuid)}
                alt={`QR ${code.qrUuid}`}
              />
              <div className="qr-label-value">{code.qrUuid}</div>
              <div className="qr-label-caption">
                Scanning opens the public loyalty page with this QR code prefilled.
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QrLabelPrintPage;
